import { AxiosError } from 'axios';
import adminApi from '../api/adminApi';
import api from '../api/api';
import useStore from '../store/store';

interface UpdateKitParams {
    kitId: number;
    sampleId?: string;
    nickname?: string;
    trf?: File;
    termsVersion?: number;
    isAdmin?: boolean;
}

const UpdateKit = async (params: UpdateKitParams) => {
    const { setFormError, setIsLoading } = useStore.getState();

    setIsLoading(true);
    try {
        const formData = new FormData();
        formData.append('kitId', params.kitId.toString());
        if (params.sampleId) formData.append('sampleId', params.sampleId);
        if (params.nickname) formData.append('nickname', params.nickname);
        if (params.trf) formData.append('trf', params.trf);
        if (params.termsVersion)
            formData.append('termsVersion', params.termsVersion.toString());

        if (params.isAdmin) {
            const response = await adminApi.post('/kit/update', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            const { success, errCode } = response.data;
            if (success) {
                setFormError('');
            } else if (errCode) {
                setFormError(errCode);
            } else {
                setFormError('other');
            }
        } else {
            const response = await api.post('/kit/update', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            const { success, errCode } = response.data;
            if (success) {
                setFormError('');
            } else if (errCode) {
                setFormError(errCode);
            } else {
                setFormError('other');
            }
        }
    } catch (e: unknown) {
        if (e instanceof AxiosError) {
            console.error(e.response?.data);
            setFormError('');
            setTimeout(() => setFormError(e.code ?? 'other'), 0);
        } else {
            setFormError('');
            setTimeout(() => setFormError('other'), 0);
        }
    } finally {
        setIsLoading(false);
    }
};

export default UpdateKit;
